import { Button, Segment } from 'semantic-ui-react'
import Flexbox from 'flexbox-react'
import Play from '../../components/Play'
import PropTypes from 'prop-types'
import React from 'react'
import _ from 'lodash'
import injectSheet from 'react-jss'

const videosStyles = {
	buttonWrapper: {
		width: '100%'
	},
	button: {
		margin: '10px !important'
	},
	playContainer: {
		width: '100%'
	}
}
function VideosVanilla({ classes, exampleVideos, switchToRecordTab }) {
	if (0 === exampleVideos.length) {
		return (
			<Segment basic>
				<h2>
					No example videos

				</h2>
				<Button
					onClick={switchToRecordTab}
					content="Record a video"
					primary
					icon="edit"
					size="massive"
				/>
				<br />
				<br />
				Recorded videos publicly show here
			</Segment>
		)
	}
	const reactions = ['thumbs up']
	return (
		<div>
			<Flexbox flexDirection="row">
				<Flexbox flexGrow={1}>
					<div className={classes.playContainer}>
						<Play
							src={`https://res.cloudinary.com/zinid/video/upload/ac_aac,af_44100,c_fill,f_mp4,g_center,h_640,q_70,vc_h264:main:3.1,w_640/v1498748174/${exampleVideos[0]}.mp4`}
							loop
						/>
					</div>
				</Flexbox>
				<Flexbox flexShrink={1}>
					<Flexbox flexDirection="column">
						{_.map(reactions, reaction =>
							<Flexbox key={reaction} flexGrow={1}>
								<Flexbox
									justifyContent="center"
									alignItems="center"
									className={classes.buttonWrapper}
								>
									<Button
										primary
										icon={reaction}
										size="massive"
										className={classes.button}
									/>
								</Flexbox>
							</Flexbox>
						)}
						<Flexbox flexGrow={1}>
							<Flexbox
								justifyContent="center"
								alignItems="center"
								className={classes.buttonWrapper}
							>
								<Button primary icon="star" size="massive" className={classes.button} />
							</Flexbox>
						</Flexbox>
					</Flexbox>

				</Flexbox>
			</Flexbox>
		</div>
	)
}
VideosVanilla.propTypes = {
	classes: PropTypes.object,
	exampleVideos: PropTypes.arrayOf(PropTypes.string),
	switchToRecordTab: PropTypes.func.isRequired
}
const Videos = injectSheet(videosStyles)(VideosVanilla)

export default Videos



// WEBPACK FOOTER //
// ./src/pages/Do/Videos.js